import PropTypes from "prop-types";

import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import {
  Flex,
  Modals,
  AppContainer,
  Notifications,
} from "@ubisend/pulse-components";

import { useAuth } from "../hooks";
import Sidebar from "./Sidebar";

const Layout = ({ children }) => {
  const { authenticated } = useAuth();

  return (
    <>
      <Modals />
      <Notifications />
      {authenticated ? (
        <Flex>
          <Sidebar />
          <AppContainer>{children}</AppContainer>
        </Flex>
      ) : (
        <>{children}</>
      )}
      <ReactQueryDevtools initialIsOpen={false} />
    </>
  );
};

Layout.propTypes = {
  children: PropTypes.any,
};

export default Layout;
